import { useEffect, useState } from "react";

interface ImgProps {
    src: string;
    alt: string;
    height?: string | number;
    width?: string | number;
    className?: string;
    loading?: "eager" | "lazy" | undefined;
    style?: object;
}

const Img = ({ src, alt, height, width = '100%', className, loading, style }: ImgProps): JSX.Element => {
    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    useEffect(() => {
        const image = new Image();
        image.src = src;
        image.onload = () => image.complete ? setIsLoaded(true) : false
        image.onerror = () => {
            console.log("[ERROR]Failed to open img :", alt)
        }
    }, [src, alt])
    return (
        <>
            {
                isLoaded ?
                    <img
                        {...{
                            src, alt, height, width, className: className + ' object-cover', loading, style
                        }}
                    />
                    :
                    <span  
                    {...{
                        height, width, className: className, style: {...style, height, width}
                    }}
                    className={`rounded bg-slate-200 p-3 animate-pulse block ${className}`}></span>
            }
        </>
    )
}

export default Img